const activeBarOptions = function activeBarOptions() {
  return {
    color: ['#02A9F1'],
    tooltip: {
      // trigger: 'axis',
      backgroundColor: "#fff",
      textStyle: {
        color: "#FFAE00",
      },
      padding: [15, 30],
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'none', // 默认为直线，可选为：'line' | 'shadow'
      },
      extraCssText: 'box-shadow:0px 6px 13px 0px rgba(65,140,231,0.18);text-align:center;',
      formatter(params) {
        return `${params.value}笔<br>${params.name}`;
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [{
      type: 'category',
      offset: 15,
      data: [],
      axisTick: {
        alignWithLabel: true,
      },
    }],
    yAxis: [{
      type: 'value',
      offset: 15,
    }],
    series: [{
      name: '直接访问',
      type: 'bar',
      barWidth: '30%',
      itemStyle: {
        emphasis: { color: '#FFAE00' }, // 鼠标滑过柱子颜色变化
      },
      data: [],
    }],
  };
};

export default activeBarOptions;
